import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputDateUI from "../../../widgets/form/InputDateUI";

const CustomerInvoicesDisburseModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, onSubmit, submitted, onCancelCreate,
  disbursedDate, onDisbursedDateChange, disbursedDateError, setDisbursedDateError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Disburse customer invoice'
    buttonLabel='Disburse'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelCreate}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputDateUI context={context} type='text' name='disbursedDate' 
      label='Disbursed date'
      selectedDateISO={disbursedDate} onChange={onDisbursedDateChange}
      error={disbursedDateError} setError={setDisbursedDateError}
    />
  </ModalFormUI>

export default CustomerInvoicesDisburseModalUI;
